
export default function FamilyGroupTab() {
  return (
    <div className="terms-conditon-tab w-full">
      <div className="terms-condition-wrappr w-full overflow-auto">
        <div className="mb-8">
          <h1 className="text-xl tracking-wide font-bold text-dark-gray dark:text-white mb-4">
            Family/Group Coming Soon!!!
          </h1>
        </div>
      </div>
    </div>
  );
}
